export default __webpack_public_path__ + "static/media/ThinkExim.121b9f8f83ed4c65dee27245b7df73d7.webp";